import * as React from "react";
import "./App.css";
import 'react-toastify/dist/ReactToastify.css';
import { AppRoutes } from './routes';
import {AppProvider} from './providers/app'

function App() {
  return (
    <AppProvider>
    <AppRoutes />
  </AppProvider>
  );
}



export default App;
